import { render, staticRenderFns } from "./CreateCourse.vue?vue&type=template&id=0172dbaa&scoped=true"
import script from "./CreateCourse.vue?vue&type=script&lang=js"
export * from "./CreateCourse.vue?vue&type=script&lang=js"
import style0 from "./CreateCourse.vue?vue&type=style&index=0&id=0172dbaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172dbaa",
  null
  
)

export default component.exports